package ir.site.zero1plus.model

enum class NavBarMenu(
    val id: String,
    val path: String,
    val title: String,
    val desc: String,
) {
    Home(
        id = "home",
        path = "#home",
        title = "خانه",
        desc = ""
    ),
    AboutMe(
        id = "aboutme",
        path = "#aboutme",
        title = "درباره من",
        desc = ""
    ),
    License(
        id = "license",
        path = "#license",
        title = "مجوزها",
        desc = ""
    ),
    ContactDetails(
        id = "contact",
        path = "#contact",
        title = "ارتباط با من",
        desc = ""
    ),
}